import { render, staticRenderFns } from "./student-round-view.vue?vue&type=template&id=0e1c9af0&scoped=true&"
import script from "./student-round-view.ts?vue&type=script&lang=ts&"
export * from "./student-round-view.ts?vue&type=script&lang=ts&"
import style0 from "./student-round-view.scss?vue&type=style&index=0&id=0e1c9af0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1c9af0",
  null
  
)

export default component.exports